import axios from 'axios';
import { env } from '@/lib/env';

/**
 * Settings MCP routes live on aistudioapi in local dev (no Cognito required).
 * Prefer REACT_APP_VIBE_CODING_STUDIO_URL when BACKEND_URL points at authapi.
 * Prod gateway: base ends with /backend → /backend/api/settings.
 * Local aistudio: base ends with /api → /api/settings.
 */
export function getMcpSettingsApiBase() {
  const base =
    (env('REACT_APP_VIBE_CODING_STUDIO_URL') || env('REACT_APP_BACKEND_URL') || '').replace(
      /\/$/,
      '',
    );
  if (!base) return '';

  if (base.endsWith('/backend')) {
    return `${base}/api/settings`;
  }

  if (base.endsWith('/api')) {
    return `${base}/settings`;
  }

  return `${base}/api/settings`;
}

const API = getMcpSettingsApiBase();

/** ^[a-z][a-z0-9_]{0,63}$ — must start with a letter. */
export const MCP_DISPLAY_NAME_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;

export function normalizeMcpDisplayName(raw) {
  return (raw || '').trim().toLowerCase();
}

export function validateMcpDescription(raw) {
  const description = (raw || '').trim();
  if (!description) {
    return 'Description is required — agents use this to choose the right MCP server';
  }
  return null;
}

export function validateMcpDisplayName(raw) {
  const name = normalizeMcpDisplayName(raw);
  if (!name) return 'Display name is required';
  if (!MCP_DISPLAY_NAME_PATTERN.test(name)) {
    return 'Use lowercase letters, digits, and underscores only; must start with a letter';
  }
  return null;
}

export async function fetchMcpServers() {
  const { data } = await axios.get(`${API}/mcp-servers`);
  return data;
}

export async function fetchMcpServer(serverId) {
  const { data } = await axios.get(`${API}/mcp-servers/${serverId}`);
  return data;
}

export async function testMcpServerConfig(payload) {
  const { data } = await axios.post(`${API}/mcp-servers/test`, payload);
  return data;
}

export async function createMcpServer(payload) {
  const { data } = await axios.post(`${API}/mcp-servers`, payload);
  return data;
}

export async function updateMcpServer(serverId, payload) {
  const { data } = await axios.put(`${API}/mcp-servers/${serverId}`, payload);
  return data;
}

export async function deleteMcpServer(serverId) {
  const { data } = await axios.delete(`${API}/mcp-servers/${serverId}`);
  return data;
}

export async function testMcpServer(serverId) {
  const { data } = await axios.post(`${API}/mcp-servers/${serverId}/test`);
  return data;
}

export async function fetchAgentMcpServers(agentId) {
  const { data } = await axios.get(`${API}/agent-mcp/${agentId}/servers`);
  return data;
}

export async function fetchMcpServerCredentials(serverId) {
  const { data } = await axios.get(`${API}/mcp-servers/${serverId}/credentials`);
  return data;
}
